export default __webpack_public_path__ + "static/media/IMG_8723 copie.e873eee9.jpg";